import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { kv, activity } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function SupplierDetail() {
  const { L } = useApp();

  const supInfo = [
    kv(L('Supplier ID', 'รหัสซัพพลายเออร์'), 'SUP-006', 'var(--font-mono)'),
    kv(L('Tax ID', 'เลขประจำตัวผู้เสียภาษี'), '0105545006677', 'var(--font-mono)'),
    kv(L('Category', 'หมวดหมู่'), L('Insurance', 'ประกันภัย'), 'var(--font-sans)'),
    kv(L('Registry', 'ทะเบียน'), L('Verified', 'ยืนยันแล้ว'), 'var(--font-sans)'),
    kv(L('Contact', 'ผู้ติดต่อ'), 'claims@pacific-ins.co', 'var(--font-mono)'),
    kv(L('Phone', 'โทรศัพท์'), '+66 2 555 0606', 'var(--font-mono)'),
  ];
  const supMetrics = [
    { label: L('Overall Score', 'คะแนนรวม'), val: 54 },
    { label: L('On-Time Delivery', 'การจัดส่งตรงเวลา'), val: 61 },
    { label: L('Quality Score', 'คะแนนคุณภาพ'), val: 58 },
  ].map((m) => ({
    ...m,
    w: m.val + '%',
    color: m.val >= 85 ? 'var(--color-success)' : m.val >= 65 ? 'var(--color-warning)' : 'var(--color-error)',
  }));
  const supFooter = [
    kv(L('Total Orders', 'คำสั่งซื้อทั้งหมด'), '12', 'var(--font-mono)'),
    kv(L('Total Value', 'มูลค่ารวม'), '$2.10M', 'var(--font-mono)'),
    kv(L('Avg Response', 'เวลาตอบเฉลี่ย'), L('3.4 days', '3.4 วัน'), 'var(--font-sans)'),
    kv(L('Last Activity', 'กิจกรรมล่าสุด'), '2026-05-30', 'var(--font-mono)'),
  ];
  const supDirectors = [
    { name: 'Daniel Coleman', note: L('Also directs Apex, Summit', 'ดำรงตำแหน่งกรรมการที่ Apex, Summit ด้วย') },
    { name: 'Marcus Reed', note: L('No other links', 'ไม่มีความเชื่อมโยงอื่น') },
  ];
  const supTimeline = [
    activity('alert-triangle', 'alert', L('Suspended from ASL — compliance review', 'ถูกระงับจาก ASL — การตรวจสอบการปฏิบัติตามข้อกำหนด'), '2026-06-01'),
    activity('alert-triangle', 'alert', L('COI flag raised (RPT-2026-002)', 'พบสัญญาณ COI (RPT-2026-002)'), '2026-05-22'),
    activity('receipt', 'info', L('Invoice submitted — INV-2025-0980', 'ส่งใบแจ้งหนี้แล้ว — INV-2025-0980'), '2026-04-10'),
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', background: 'var(--color-error-bg)', border: '1px solid var(--color-error)', borderRadius: 'var(--radius-md)', marginBottom: 16, color: 'var(--color-error)' }}>
        <Icon name="alert-triangle" style={{ fontSize: 20 }} />
        <div style={{ fontSize: 13, color: 'var(--color-fg-1)' }}>
          <b>{L('Suspended', 'ระงับ')}</b> — {L('Pacific Insurance Co. is suspended from the ASL. No new RFQ invitations should be issued until compliance review is complete.', 'Pacific Insurance Co. ถูกระงับจาก ASL ไม่ควรออกคำเชิญ RFQ ใหม่จนกว่าการตรวจสอบการปฏิบัติตามข้อกำหนดจะเสร็จสิ้น')}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardPad(20)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <span style={{ width: 44, height: 44, borderRadius: 'var(--radius-sm)', background: 'var(--color-ink-50)', color: 'var(--color-fg-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>PI</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16 }}>Pacific Insurance Co.</div>
                <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-error-bg)', color: 'var(--color-error)' }}>{L('Suspended', 'ระงับ')}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{L('Tier 2', 'ระดับ 2')}</span>
                </div>
              </div>
            </div>
            {supInfo.map((d) => (
              <div key={d.k} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid var(--color-border)', fontSize: 13 }}>
                <span style={{ color: 'var(--color-fg-3)' }}>{d.k}</span>
                <span style={{ fontWeight: 600, fontFamily: d.font }}>{d.v}</span>
              </div>
            ))}
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Performance Metrics', 'ตัวชี้วัดผลงาน')}</div>
            {supMetrics.map((m) => (
              <div key={m.label} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 5 }}>
                  <span style={{ fontWeight: 500 }}>{m.label}</span>
                  <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: m.color }}>{m.val}</span>
                </div>
                <div style={{ height: 8, borderRadius: 999, background: 'var(--color-ink-50)', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: m.w, background: m.color }} />
                </div>
              </div>
            ))}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 10, marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--color-border)' }}>
              {supFooter.map((f) => (
                <div key={f.k}>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{f.k}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, fontFamily: f.font }}>{f.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Compliance Flags', 'สัญญาณการปฏิบัติตามข้อกำหนด')}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div style={{ border: '1px solid var(--color-error)', background: 'var(--color-error-bg)', borderRadius: 'var(--radius-sm)', padding: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('COI Flags', 'สัญญาณ COI')}</div>
                <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'var(--font-mono)', color: 'var(--color-error)' }}>3</div>
              </div>
              <div style={{ border: '1px solid var(--color-error)', background: 'var(--color-error-bg)', borderRadius: 'var(--radius-sm)', padding: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Collusion Score', 'คะแนนการสมรู้ร่วมคิด')}</div>
                <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'var(--font-mono)', color: 'var(--color-error)' }}>81</div>
              </div>
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--color-fg-3)', marginBottom: 8 }}>{L('SHARED DIRECTORS', 'กรรมการร่วม')}</div>
            {supDirectors.map((d) => (
              <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ width: 8, height: 8, borderRadius: 999, background: 'var(--color-warning)', flex: 'none' }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{d.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{d.note}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Activity Timeline', 'ไทม์ไลน์กิจกรรม')}</div>
            {supTimeline.map((a, i) => (
              <div key={i} style={{ display: 'flex', gap: 11, padding: '9px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ width: 10, height: 10, borderRadius: 999, background: a.color, flex: 'none', marginTop: 4 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13 }}>{a.text}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)', fontFamily: 'var(--font-mono)' }}>{a.time}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
